import { render, staticRenderFns } from "./SacAgendamentoPrincipal.vue?vue&type=template&id=22d41d2e&"
import script from "./SacAgendamentoPrincipal.vue?vue&type=script&lang=js&"
export * from "./SacAgendamentoPrincipal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports